import styled from 'styled-components/native';
import style, { hpx, wpx } from '../../styles';

export const Container = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const FlagButton = styled.TouchableOpacity`
  padding: ${hpx(2)} ${wpx(4)};
  opacity: ${props => (props.active ? 1 : 0.4)};
`;

export const FlagText = styled.Text`
  font-size: 20px;
`;

export const LoadingText = styled.Text`
  font-size: ${style.fonts.xxsmall};
  color: #999;
  margin-left: ${wpx(4)};
  font-family: ${style.fontName.ubuntuRegular};
`;
